module.exports = __webpack_public_path__ + "media/images/pokerroom/888/logo-small-e2b4166761b82b14e3a165a1ea2e1e52.png";